import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { ApiService } from '../../services/API/api.service';
import { AddressCompany, Open, typeInterface } from 'src/app/shared/Interfaces/company';
import { DOCUMENT } from '@angular/common';
import { ScrollService } from '../../services/Scroll/scroll.service';

@Component({
  selector: 'app-info-company',
  templateUrl: './info-company.component.html',
  styleUrl: './info-company.component.css'
})
export class InfoCompanyComponent implements OnInit, AfterViewInit, OnChanges{
  @ViewChild('offCanva') offCanva!: ElementRef
  @Input() openInfo: boolean = false;
  private typeParam!: typeInterface;
  @Output() closeInfo: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  nameCompany: string = '';
  company!: Company;
  opening!: Open;
  addressCompany!: AddressCompany;
  addressUrl: string = '';
  timesInfo: any;
  local: boolean = false;
  readOnlyState: boolean = false;
  offCanvasHeight: string | number = window.innerHeight * 0.9;
  initHeight: number = window.innerHeight * 0.9;
  localCounter: boolean = false;

  private startY = 0;
  private isDragging = false;
  hiddenButton: boolean = false;

  scrollElement!: HTMLElement

  constructor(
    private connection: ConnectionService,
    public scrollService: ScrollService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
  )
  {
    this.connection.nameCompany$.subscribe((newNameCompany: string) => {
      this.nameCompany = newNameCompany;
    })

    this.connection.company$.subscribe((data) =>{
      this.company = data
      if(this.company){
        this.opening = this.company.company.open
        this.addressCompany = this.company.company.address;
        this.formattedAddress();
        this.validTimes()
      }
    })

    this.connection.typeParam$.subscribe((newTypeParam) => {
      this.typeParam = newTypeParam;
    })

    this.connection.readOnlyState$.subscribe((data) =>{
      this.readOnlyState = data;
    })
    
  }

  ngOnInit(): void {
    if(this.typeParam.type == 1 || this.typeParam.type == 2){
      this.local = true;
    }
    else{
      this.local = false;
    }

    if(this.typeParam.type == 3){
      this.localCounter = true;
    }
    else{
      this.localCounter = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['openInfo'].currentValue == true){
      this.scrollService.disableScroll();
    }
    else{
      this.scrollService.enableScroll();
    }
  }

  ngAfterViewInit(): void {
  }

  formattedAddress(){
    if(this.company){
      const address = this.company.company.address;
      const addressCompletted = `${address.street}, ${address.number} - ${address.district}, ${address.city} - ${address.state}, ${address.country}`;

      const addressCodificate = encodeURIComponent(addressCompletted);
      this.addressUrl = `https://www.google.com/maps/search/?api=1&query=${addressCodificate}`
    }

  }


  validTimes() {
    const { deliveryFrom, deliveryTo, counterFrom, counterTo } = this.company.company.times;
  
    this.timesInfo = {
      delivery: {
        active: !(deliveryFrom === 0 && deliveryTo === 0),
        label: this.formatTimeRange(deliveryFrom, deliveryTo)
      },
      counter: {
        active: !(counterFrom === 0 && counterTo === 0),
        label: this.formatTimeRange(counterFrom, counterTo)
      }
    };
  }
  
  private formatTimeRange(from: number, to: number): string {
    if (!from && !to) return '';
  
    if (from && to) {
      return `${this.formatMinutes(from)} - ${this.formatMinutes(to)}`;
    }
  
    const value = from || to;
    return this.formatMinutes(value);
  }
  
  private formatMinutes(minutes: number): string {
    if (!minutes) return '';
  
    if (minutes < 60) return `${minutes} min`;
  
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
  
    if (hours && mins) {
      return `${hours}h${mins}`;
    }
  
    return `${hours}h`;
  }


  //Quando o usuario clica
  onTouchStart(event: any) {
    const clientY =
      event.touches?.[0]?.clientY ?? // touch
      event.clientY; // mouse

    this.startY = clientY;
    this.isDragging = true;
    this.scrollElement = event.currentTarget as HTMLElement;
  }

  onTouchMove(event: any) {
    // Só movimenta se o usuário estiver arrastando (clicando ou tocando)
    if (!this.isDragging) return;

    // Em eventos de mouse, ignorar se o botão não estiver pressionado
    if (event instanceof MouseEvent && event.buttons === 0) return;

    const clientY =
      event.touches?.[0]?.clientY ??
      event.clientY;

    const deltaY = clientY - this.startY;

    if (this.scrollElement.scrollTop === 0 && deltaY > 0) {
      this.offCanvasHeight = Math.max(0, this.initHeight - deltaY);
    }
  }

  // Finalizar o toque
  onTouchEnd() {
    this.isDragging = false;

    // Fechar se a altura for pequena
    if (Number(this.offCanvasHeight) < 300) {
      this.closeOffCanvas();
    } else {
      this.offCanvasHeight = this.initHeight; // Resetar altura
    }
  }


  closeOffCanvas() {
    this.openInfo = false;
    this.offCanvasHeight = this.initHeight;
    this.closeInfo.emit(false);
    setTimeout(() => {
      this.scrollService.enableScroll();
    }, 500);
  }

  //Desabilita o scroll da pagina
  disableScroll(){
    this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
  }

  //Habilita o scroll da pagina
  enableScroll(){
    this.renderer.removeStyle(this.document.body, 'overflow');
  }
  
}
